module.exports = __webpack_public_path__ + "static/media/imageedit_7_6831998141.3954ad23.png";